import {Route, Routes} from "react-router-dom";
import DashboardPage from "./Dashboard/DashboardPage";
import OnboardingPage from "./Dashboard/Onboarding/OnboardingPage";
import InvoicesPage from "./Dashboard/InvoicesPage";
import NavigationItem from "../../Layouts/NavigationItem";
import DashboardIcon from "../../Assets/Icons/V2/DashboardIcon";
import AgreementIcon from "../../Assets/Icons/V2/AgreementIcon";
import DefaultPageLayout from "Layouts/DefaultPageLayout";
import AnnualReportsPage from "./Dashboard/AnnualReportsPage";
import {useTranslation} from "react-i18next";
import OnboardingEloverblikPage from "./Dashboard/Onboarding/OnboardingEloverblikPage";
import AgreementDetailsPage from "./Dashboard/AgreementDetailsPage";
import MenuMoreDropdown from "../../Layouts/MenuMoreDropdown";
import ContactInfoPage from "./Dashboard/ContactInfoPage";
import ChangePasswordPage from "./Dashboard/ChangePasswordPage";
import AcceptedTermsPage from "./Dashboard/AcceptedTermsPage";
import InvoiceIcon from "../../Assets/Icons/V2/InvoiceIcon";
import ReportIcon from "../../Assets/Icons/V2/ReportIcon";
import {useEffect} from "react";
import {useAuthProvider} from "../../Providers/AuthProvider";
import {Navigate, useLocation, useNavigate} from "react-router";
import Grid from "Components/Grid";
import ResourcesIcon from "../../Assets/Icons/V2/ResourcesIcon";
import ResourcesPage from "./Dashboard/ResourcesPage";

const DashboardRoutes = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const location = useLocation();

    const { userContext } = useAuthProvider();

    useEffect(() => {
        if (!!userContext && userContext.agreements.length === 1 && userContext.agreements[0].agreementStatus === "Pending") {
            if (location.pathname.includes("onboarding")) {
                return;
            }
            
            navigate(`/dashboard/${userContext.agreements[0].id}/onboarding`);
        }
    }, [location, navigate, userContext]);

    const dashboardPage = (content: any) => (
        <DefaultPageLayout contentMaxWidth={1440} menuContent={(
            <>
                <NavigationItem text={t('dashboard')}  icon={<DashboardIcon />} isExact includeSearch route={`/dashboard`} />
                <NavigationItem text={t('acceptedTerms')} icon={<ReportIcon />} includeSearch route={`/dashboard/acceptedTerms`} />
                <NavigationItem text={t('invoices')} icon={<InvoiceIcon />} includeSearch route={`/dashboard/invoices`} />
                <NavigationItem text={t('partnership')} icon={<ResourcesIcon />} includeSearch route={`/dashboard/resources`} />
                <NavigationItem text={t('agreement')} icon={<AgreementIcon />} includeSearch route={`/dashboard/details`} />
                <MenuMoreDropdown />
            </>
        )}>
            <Grid gridTemplateColumns={"1fr"} rowGap={48}>
                {content}
            </Grid>
        </DefaultPageLayout>
    )

    return (
        <Routes>
            <Route path=":agreementId/onboarding/eloverblik" element={<OnboardingEloverblikPage />} />
            <Route path=":agreementId/onboarding" element={<OnboardingPage />} />

            <Route path="invoices" element={dashboardPage(<InvoicesPage />)} />
            <Route path="acceptedTerms" element={dashboardPage(<AcceptedTermsPage />)} />
            <Route path="annualReports" element={dashboardPage(<AnnualReportsPage />)} />
            <Route path="resources" element={dashboardPage(<ResourcesPage />)} />

            <Route path="details" element={dashboardPage(<AgreementDetailsPage />)} />

            <Route path="changePassword" element={dashboardPage(<ChangePasswordPage />)} />
            <Route path="contactInfo" element={dashboardPage(<ContactInfoPage />)} />

            <Route path="/" element={dashboardPage(<DashboardPage />)} />

            <Route path="*" element={<Navigate to={`/dashboard`}  />} />
        </Routes>
    )
}

export default DashboardRoutes
